<div *ngIf="convo.plot_generation_status == false">
  <div class="d-flex align-items-center gap-2">
    <span
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    <span>Generating charts</span>
  </div>
</div>
<div
  *ngIf="
    convo.plot_generation_status &&
    convo.canGeneratePlot &&
    convo.queryResults.length &&
    convo.graphs
  "
>
  <div class="mb-2" *ngIf="!onlyGraph" class="chart-actions">
    <div class="row row-cols-24 mt-2 g-1" style="width: 100% !important">
      <mat-form-field class="w-full col-sm-12 col-md-3" appearance="outline">
        <mat-label>Graph Type</mat-label>
        <mat-select
          [(ngModel)]="convo.selectedGraph"
          (selectionChange)="graphSelectionChange($event)"
        >
          <mat-option
            *ngFor="let graphType of convo.graphTypes"
            [value]="graphType"
            >{{ graphType }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="d-flex justify-content-end"></div>

    <div
      *ngIf="availableGraph(convo.selectedGraph)"
      class="graph-container mt-2 d-flex align-items-center justify-content-center"
    >
      <div [id]="chatIndex.toString() + '_hichart'"></div>
    </div>
    <div
      *ngIf="!availableGraph(convo.selectedGraph)"
      class="graph-container mt-2 d-flex align-items-center justify-content-center"
    >
      Selected Graph is not available currently!
    </div>
  </div>
  <div class="" *ngIf="onlyGraph">
    <div
      *ngIf="availableGraph(convo.selectedGraph)"
      class="graph-container d-flex align-items-center justify-content-center"
      [id]="chatIndex.toString() + '_hichart'"
      style="min-width: 310px; max-width: 100%"
    ></div>
    <div
      *ngIf="!availableGraph(convo.selectedGraph)"
      class="graph-container mt-2 d-flex align-items-center justify-content-center"
    >
      Selected Graph is not available currently!
    </div>
  </div>
</div>
